const Header = ({ route, onHandleRoute }) => {
    return (
        <header className="App-header">
            <div className="app-header-content">
                <a href="https://alsfund.ru/">
                    <img src={process.env.PUBLIC_URL + 'logo.svg'} />
                </a>
                {route !== 'home' && (
                    <button
                        className="back-arrow"
                        onClick={() => onHandleRoute('home')}
                    >
                        Вернуться
                    </button>
                )}
            </div>
        </header>
    )
}

export default Header
